<div class="main-no-background flex f-fd--column f-gap--45px f-jc--center f-ai--center">
  <span i18n="@@front-login.sucess.title">Inicio de sesión correcto, continúe la navegación</span>
  <button mat-raised-button color="primary" (click)="goCallBack()" i18n="@@front-login.sucess.action">
    Continuar
  </button>
</div>
